<template>
  <section class="space">
    <el-page-header @back="goBack" content="收益提现">
    </el-page-header>
    <div style="height:30px"></div>
    <div class="space-search">
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="停车场:">
          <el-select
            class="space-parking"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="{ parkingId, parkingName } in parks"
              :key="parkingId"
              :value="parkingId"
              :label="parkingName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="共享车位号:" v-if="type == 'space'">
          <el-select
            class="park-parking"
            placeholder="请选择"
            clearable
            filterable
          >
            <el-option
              v-for="{ parkingId, parkingName } in parks"
              :key="parkingId"
              :value="parkingId"
              :label="parkingName"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item>
    <el-button type="primary" @click="onSubmit">查询</el-button>
  </el-form-item> -->
      </el-form>
    </div>
    <div class="gap"></div>
    <section class="account-content">
      <div class="account balance">
        <img
          src="../../../assets/images/split-account/balance.svg"
          style="color:#10AEFF; width:80px;height:auto;"
        />
        <span>账户余额(元)</span>
        <el-divider></el-divider>
        <span>¥308.85</span>
        <span class="cash-out"> 去提现</span>
      </div>

      <div class="account add">
        <img
          src="../../../assets/images/split-account/add.svg"
          style="color:#10AEFF;width:80px;height:auto;"
        />
        <span>今日新增(元)</span>
        <el-divider></el-divider>
        <span>¥308.85</span>
        <span class="cash-out"> 去提现</span>
      </div>
      <div class="account withdrawl">
        <h6 class="withdrawl-title">提现信息</h6>
        <div class="gap"></div>
        <el-form label-width="80px">
          <el-form-item label="提现金额">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="提现密码">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="财务电话">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input></el-input>
          </el-form-item>
        </el-form>
        <span class="cash-out submit"> 提交</span>
      </div>
    </section>
    <section>
      <div class="gap"></div>
      <div class="payment">
        <div class="payer">
          <h3>付款方信息</h3>
          <el-divider></el-divider>
        <ul>
          <li>
            <span>付款方式:</span>
          </li>
        </ul>
  
        </div>
      <div class="payee">
        <h3>收款方信息</h3>
        <el-divider></el-divider>
        <ul>
            <li>
              <span>开户名称:</span>
            </li>
            <li>
              <span>开户渠道:</span>
            </li>
            <li>
              <span>开户账户:</span>
            </li>
          </ul>
      </div>
        
        </div>
  
    </section>
  </section>
</template>
<script>
import { shareParks } from "@/api/url";
export default {
  data() {
    return {
      type: "park",
      parks: [],
      dates: {
        today: "今日",
        yesterday: "昨日",
        lastWeek: "上周",
        lastMonth: "上月",
      },
      activeName: "today",
    };
  },
  mounted() {
    this.getShareParks();
    this.type = this.$route.query?.type ?? "park";
  },
  methods: {
    getShareParks() {
      this.$postRequest(shareParks(), {}).then((res) => {
        this.parks = res?.data?.data?.rows ?? [];
      });
    },
    goBack() {
        this.$router.go(-1);
      }
  },
};
</script>
<style scoped>
.space {
  height: 100%;
  padding: 20px;
  overflow-y: auto;
}
.space-search {
  display: flex;
  align-items: center;
}
.space-title {
  color: #666;
  font-weight: bold;
  font-size: 18px;
  margin-right: 10px;
}
.space-parking {
  width: 300px;
}
.account-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.account {
  width: 25%;
  height: 300px;
  text-align: center;
  border: 1px solid #eee;
  border-radius: 10px;
  margin: 0 auto;
  padding: 50px;
  box-sizing: border-box;
}
.account span {
  display: block;
  color: #777;
  font-size: 18px;
  font-weight: bold;
  padding: 5px 0;
  box-sizing: border-box;
}
span.cash-out {
  width: 150px;
  height: 30px;
  background: #188fff;
  color: white;
  margin: 0 auto;
  font-size: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
}
.summary-title {
  font-size: 20px;
  color: #666;
  font-weight: bold;
}
.account.withdrawl {
  padding: 10px;
  box-sizing: border-box;
}
.withdrawl-title {
  font-size: 20px;
  font-weight: bold;
}
.payment{
  width:100%;
  display:flex;
  justify-content: space-around;
  align-items:center ;
}
.payment ul{
 
}
.payer,.payee{
  background: #eee;
  width:45%;
  height:300px;
  border-radius: 10px;
  padding:20px;
  box-sizing: border-box;
}
.payment ul li{
  padding:10px 0;
  font-size:16px;
  font-weight: bold;
}
.cash-out.submit{
 
}
.gap {
  height: 20px;
}
</style>
<style>
.space .el-divider--horizontal {
  margin: 10px;
}
.space .space-search .el-input__inner {
  height: 20px;
  border-radius: 5px;
}
.space .space-search .el-form-item__label {
  font-weight: bold;
  color: #888;
}
.space .space-search .el-date-editor {
  height: 30px;
}
.space .account .el-form-item {
  height: 40px;
  margin: 2px 0;
}
.space .space-search .el-input__inner {
  height: 40px;
  border-radius: 5px;
}
</style>
